<template>
  <div class="page-wrap">
    <!-- HERO CAROUSEL -->
    <section class="hero-carousel">
      <div class="carousel-wrap">
        <div class="carousel-slide" :class="{ active: currentIndex === index }" v-for="(item, index) in carouselSlideList" :key="index">
          <img class="carousel-slide-img" :src="imgUrlPrefix + item.banner" :alt="item.title" />
          <div class="slide-card">
            <div class="slide-user">
              <div class="slide-avatar">
                <img class="slide-avatar-img" :src="userHeadPrefix + item.avatarImg" :alt="item.avatarName" />
              </div>
              <span class="slide-username">{{ item.avatarName }}</span>
            </div>
            <div class="slide-title">{{ item.title }}</div>
            <!-- <div class="slide-tag">{{ item.tag }}</div> -->
            <button class="slide-btn" @click="openLink(item.link)">了解更多 →</button>
          </div>
        </div>
        <!-- Dots -->
        <div class="carousel-dots">
          <div class="carousel-dot" :class="{ active: currentIndex === index }" @click="goToSlide(index)" v-for="(_, index) in carouselSlideList" :key="index"></div>
        </div>
      </div>
    </section>
    <!-- ACTIVITY BAR -->
    <div class="activity-bar fade-up">
      <div class="bar-date">
        活动进行中<br>2026.05 — 2026.07
      </div>
      <div class="bar-divider"></div>
      <div class="bar-content">
        <div class="bar-title">越野副本创作大赛 · 第一章</div>
        <div class="bar-sub">设计你心目中最极限的越野副本地图，最优方案将被纳入游戏关卡。</div>
      </div>
      <div class="bar-right">
        <span class="bar-count">1,247 人参与</span>
        <button class="bar-join" @click="openLink(mainJoinUrl)">立即参与 +</button>
      </div>
    </div>
    <!-- ACTIVITY MODULE -->
    <section class="activity-module" :class="index % 2 === 0 ? 'bg-white' : 'bg-light'" v-for="(item, index) in activityList" :key="index">
      <div class="activity-inner">
        <div class="act-text fade-up">
          <div class="act-eyebrow">{{ item.eyebrow }}</div>
          <h2 class="act-title">{{ item.title }}</h2>
          <p class="act-desc" v-html="item.desc"></p>
          <div class="act-date">Date: {{ item.date }}</div>
          <button class="act-join" @click="openLink(item.link)">参与 JOIN</button>
        </div>
        <CommunityActCardList :card-list="item.cardList" :img-url-prefix="imgUrlPrefix" :user-head-prefix="userHeadPrefix" />
      </div>
    </section>
    <!-- FOOTER CTA -->
    <footer class="footer-cta">
      <h2 class="footer-heading fade-up">你的创作，可能是下一辆 METTA 的起点</h2>
      <p class="footer-body fade-up" style="transition-delay:0.06s">
        每一次提交，都是和 METTA 共同创造的机会。<br>
        加入社区，让你的想法被看见。
      </p>
      <div class="footer-btns fade-up" style="transition-delay:0.12s">
        <button class="btn-outline-white" @click="openLink(allActivityUrl)">查看全部活动</button>
        <button class="btn-white" @click="openLink(submitUrl)">提交我的作品 →</button>
      </div>
      <div class="footer-copy fade-up" style="transition-delay:0.18s">METTA · 麦塔社区 © 2026</div>
    </footer>
  </div>
</template>

<script>
import CommunityActCardList from '../components/community/ActCardList.vue'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
let timer = null;
export default {
  components: {
    CommunityActCardList
  },
  mounted() {
    this.startCarousel();
    fadeAnimate();
  },
  beforeDestroy() {
    clearInterval(timer);
    destroyFadeAnimate();
  },
  data() {
    return {
      mainJoinUrl: 'https://community-metta.sixeco.com',
      allActivityUrl: 'https://community-metta.sixeco.com',
      submitUrl: 'https://community-metta.sixeco.com',
      imgUrlPrefix: '/assets/images/community/',
      userHeadPrefix: '/assets/images/userHead/',
      carouselSlideList: [
        {
          banner: 'gfcgd.jpg',
          title: '共赴闯关点',
          avatarImg: '1.png',
          avatarName: '7743',
          link: 'https://community-metta.sixeco.com'
        },
        {
          banner: 'gjyyjd.jpg',
          title: '共建越野基地',
          avatarImg: '2.png',
          avatarName: 'Ray',
          link: 'https://community-metta.sixeco.com'
        },
        {
          banner: 'lljx.jpg',
          title: '拉力觉醒',
          avatarImg: '3.png',
          avatarName: 'Kael',
          link: 'https://community-metta.sixeco.com'
        }
      ],
      currentIndex: 0,
      activityList: [
        {
          eyebrow: 'CREATION · 副本创作',
          title: '越野副本创作大赛',
          desc: '设计你心目中最极限的越野副本地图。<br>创作者将与 METTA 游戏团队共同还原，<br>最优方案直接纳入游戏关卡。',
          date: '2026.05.01 — 07.31',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'bdmg.jpg', name: '巴丹迷宫', avatarImg: '1.png', avatarName: 'Nova' },
            { img: 'shfb.jpg', name: '沙海副本', avatarImg: '2.png', avatarName: 'Ray' },
            { img: 'gbtz.jpg', name: '戈壁挑战', avatarImg: '3.png', avatarName: 'Kael' },
            { img: 'xgcy.jpg', name: '峡谷穿越', avatarImg: '4.png', avatarName: '7743' },
          ]
        },
        {
          eyebrow: 'ENGINEERING · 改造',
          title: '赛事车辆改造大赛',
          desc: '提交你的改装方案与设计理念。<br>获胜者将与 METTA 工程师团队共同研发，<br>最终方案可能成为量产套件。',
          date: '2026.06.01 — 08.15',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'qggzfn.jpg', name: '前杠改装方案', avatarImg: '5.png', avatarName: 'Sam' },
            { img: 'xgsjb.jpg', name: '悬挂升级包', avatarImg: '6.png', avatarName: '7099' },
            { img: 'lgdz.jpg', name: '轮毂定制', avatarImg: '7.png', avatarName: 'Li' },
            { img: 'sstj.jpg', name: '涉水套件', avatarImg: '8.png', avatarName: 'Benxi' },
          ]
        },
        {
          eyebrow: 'VISION · 畅想',
          title: '越野车生活方式畅想',
          desc: '用任何形式表达你理想中的越野生活方式。<br>文字、插画、视频、摄影均可，<br>优秀作品将被收录进 METTA 年度社区报告。',
          date: '2026.06.15 — 09.01',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'ygrdky.jpg', name: '一个人的旷野', avatarImg: '1.png', avatarName: 'Lisa' },
            { img: 'ywtx.jpg', name: '野外探险', avatarImg: '2.png', avatarName: 'cc' },
            { img: 'csctjh.jpg', name: '城市出逃计划', avatarImg: '3.png', avatarName: 'Apex' },
            { img: 'wmddlx.jpg', name: '无目的地旅行', avatarImg: '4.png', avatarName: 'Ning' },
          ]
        },
        {
          eyebrow: 'DESIGN · 设计',
          title: '生活方式周边创作',
          desc: '为 METTA 设计一款生活方式单品。<br>N30° 钥匙扣、真皮驾驶手套、黄铜卡片夹、沙漠主题香薰蜡烛……<br>获选设计将进入 METTA 商城正式销售，<br>设计者获得销售分成。',
          date: '2026.06.15 — 09.01',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'ysk.jpg', name: 'N30° 钥匙扣设计稿', avatarImg: '5.png', avatarName: 'Art' },
            { img: 'zpst.jpg', name: '真皮驾驶手套方案', avatarImg: '6.png', avatarName: 'Design' },
            { img: 'kpj.jpg', name: '黄铜卡片夹原型', avatarImg: '7.png', avatarName: 'Make' },
            { img: 'znz.jpg', name: '指南针', avatarImg: '8.png', avatarName: 'Craft' },
          ]
        },
        {
          eyebrow: 'PHOTO · 摄影',
          title: '越野景色摄影大赛',
          desc: '记录你在越野路上遇见的最美瞬间。<br>获奖作品将成为 METTA 官网素材库。',
          date: '2026.07.15 — 10.31',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'bdjlhh.jpg', name: '巴丹吉林黄昏', avatarImg: '1.png', avatarName: 'Lens' },
            { img: 'xsgl.jpg', name: '雪山公路', avatarImg: '2.png', avatarName: 'Eye' },
            { img: 'yhddy.jpg', name: '雨后的倒影', avatarImg: '3.png', avatarName: 'Shot' },
            { img: 'cycw.jpg', name: '峡谷晨雾', avatarImg: '4.png', avatarName: 'View' },
          ]
        },
        {
          eyebrow: 'RACING · 赛事',
          title: '赛事共创',
          desc: '参与设计下一场 METTA 赛事。<br>赛道规则、积分体系、赛事视觉——<br>你的方案可能成为下一季赛事的蓝本，<br>共创者将获得赛事冠名权与积分奖励。',
          date: '2026.08.01 — 10.31',
          link: 'https://community-metta.sixeco.com',
          cardList: [
            { img: 'llsszfa.jpg', name: '拉力赛赛制方案', avatarImg: '5.png', avatarName: 'Da112' },
            { img: 'jftxsj.jpg', name: '积分体系设计', avatarImg: '6.png', avatarName: 'sisi' },
            { img: 'fqllss.jpg', name: '发起拉力赛事', avatarImg: '7.png', avatarName: 'Doss' },
            { img: 'sdlxsj.jpg', name: '赛道路线设计', avatarImg: '8.png', avatarName: 'Ian' },
          ]
        },
      ]
    }
  },
  methods: {
    openLink(url) {
      if (!url) return;
      window.open(url, '_blank');
    },
    startCarousel() {
      timer = setInterval(() => {
        this.currentIndex = this.currentIndex === this.carouselSlideList.length - 1 ? 0 : this.currentIndex + 1;
      }, 5000);
    },
    goToSlide(i) {
      clearInterval(timer);
      this.currentIndex = i;
      this.startCarousel();
    },
  },
}
</script>

<style lang="less" scoped>
.page-wrap {
  overflow-x: hidden;

  .hero-carousel {
    height: 75vh;
    padding-top: 52px;
    position: relative;
    overflow: hidden;
    padding: 0;

    .carousel-wrap {
      width: 100%;
      height: 100%;
      position: absolute;
      inset: 0;
      border: none;
      background: #1a1a18;

      .carousel-slide {
        position: absolute;
        inset: 0;
        opacity: 0;
        transition: opacity 0.6s ease;
        pointer-events: none;

        &.active {
          opacity: 1;
          pointer-events: auto;
        }

        .carousel-slide-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .slide-card {
          position: absolute;
          bottom: 48px;
          right: 48px;
          width: 320px;
          background: rgba(8,8,8,0.72);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.1);
          padding: 24px 28px;
          z-index: 10;

          .slide-user {
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 12px;

            .slide-avatar {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              overflow: hidden;
              background: #333;
              flex-shrink: 0;

              .slide-avatar-img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }

            .slide-username {
              font-size: 10px;
              letter-spacing: 2px;
              color: rgba(255,255,255,0.5);
              font-family: 'Roboto Mono', monospace;
              font-weight: 300;
            }
          }

          .slide-title {
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            letter-spacing: -0.3px;
            margin-bottom: 8px;
          }

          .slide-tag {
            font-size: 8px;
            letter-spacing: 2px;
            text-transform: uppercase;
            color: rgba(255,255,255,0.35);
            margin-bottom: 20px;
          }

          .slide-btn {
            border: 1px solid rgba(255,255,255,0.25);
            color: #ffffff;
            padding: 9px 20px;
            font-size: 9px;
            letter-spacing: 2px;
            text-transform: uppercase;
            background: none;
            cursor: pointer;
            font-family: inherit;
            font-weight: 300;
            transition: border-color 0.2s, background 0.2s;

            &:hover {
              border-color: rgba(255,255,255,0.6);
              background: rgba(255,255,255,0.08);
            }
          }
        }
      }

      .carousel-dots {
        position: absolute;
        bottom: 24px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 6px;
        z-index: 20;

        .carousel-dot {
          width: 24px;
          height: 2px;
          background: rgba(255,255,255,0.3);
          cursor: pointer;
          transition: width 0.3s ease, background 0.3s ease;
          flex-shrink: 0;

          &.active {
            background: #ffffff;
            width: 40px;
          }
        }
      }
    }
  }

  .activity-bar {
    background: #f5f5f5;
    border-top: 1px solid @bdr;
    border-bottom: 1px solid @bdr;
    padding: 28px 44px;
    display: flex;
    align-items: center;
    gap: 32px;

    .bar-date {
      font-family: 'Roboto Mono', monospace;
      font-weight: 300;
      font-size: 11px;
      letter-spacing: 2px;
      color: @mute;
      white-space: nowrap;
      line-height: 1.8;
    }

    .bar-divider {
      width: 1px;
      height: 40px;
      background: @bdr;
      flex-shrink: 0;
    }

    .bar-content {
      flex: 1;

      .bar-title {
        font-size: 18px;
        font-weight: 300;
        color: @ink;
      }

      .bar-sub {
        font-size: 12px;
        color: @mid;
        margin-top: 4px;
      }
    }

    .bar-right {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;

      .bar-count {
        font-family: 'Roboto Mono', monospace;
        font-weight: 300;
        font-size: 11px;
        color: @mute;
        letter-spacing: 1px;
      }

      .bar-join {
        background: @ink;
        color: #ffffff;
        padding: 10px 24px;
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        font-family: inherit;
        font-weight: 300;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .footer-cta {
    background: #080808;
    padding: 80px 44px;
    text-align: center;

    .footer-heading {
      font-size: 36px;
      font-weight: 100;
      color: #ffffff;
      letter-spacing: -1px;
      margin-bottom: 20px;
    }

    .footer-body {
      font-size: 13px;
      color: rgba(255,255,255,0.4);
      max-width: 480px;
      margin: 0 auto;
      line-height: 2;
      margin-bottom: 40px;
    }

    .footer-btns {
      display: flex;
      gap: 16px;
      justify-content: center;
      flex-wrap: wrap;

      .btn-outline-white {
        border: 1px solid rgba(255,255,255,0.3);
        color: #ffffff;
        padding: 14px 32px;
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        background: none;
        cursor: pointer;
        font-family: inherit;
        font-weight: 300;
        transition: border-color 0.2s;

        &:hover {
          border-color: rgba(255,255,255,0.7);
        }
      }

      .btn-white {
        background: #ffffff;
        color: #080808;
        padding: 14px 32px;
        font-size: 9px;
        letter-spacing: 2px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        font-family: inherit;
        font-weight: 300;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.85;
        }
      }
    }

    .footer-copy {
      margin-top: 64px;
      font-size: 9px;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: rgba(255,255,255,0.2);
      font-family: 'Roboto Mono', monospace;
      font-weight: 300;
    }
  }

  .activity-module {
    padding: 80px 44px;

    &.bg-white { background: #ffffff; }
    &.bg-light { background: #f5f5f5; }

    .activity-inner {
      display: grid;
      grid-template-columns: 300px 1fr;
      gap: 64px;
      align-items: start;
      max-width: 1400px;
      margin: 0 auto;

      .act-text {
        position: sticky;
        top: 80px;

        .act-eyebrow {
          font-size: 8px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: @mute;
          margin-bottom: 16px;
          font-family: 'Roboto Mono', monospace;
          font-weight: 300;
        }

        .act-title {
          font-size: 32px;
          font-weight: 100;
          letter-spacing: -1px;
          color: @ink;
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .act-desc {
          font-size: 13px;
          color: @mid;
          line-height: 2;
          margin-bottom: 32px;
        }

        .act-date {
          font-family: 'Roboto Mono', monospace;
          font-weight: 300;
          font-size: 10px;
          letter-spacing: 2px;
          color: @mute;
          margin-bottom: 24px;
        }

        .act-join {
          border: 1px solid @ink;
          color: @ink;
          padding: 11px 28px;
          font-size: 9px;
          letter-spacing: 2px;
          text-transform: uppercase;
          background: none;
          cursor: pointer;
          font-family: inherit;
          font-weight: 300;
          transition: background 0.2s, color 0.2s;
          display: inline-block;

          &:hover {
            background: @ink;
            color: #ffffff;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .page-wrap {
    .hero-carousel {
      height: 440px;
      padding-top: 52px;

      .carousel-wrap {
        position: relative;
        height: 100%;

        .carousel-slide {
          .carousel-slide-img {
            height: 100%;
            object-fit: cover;
          }

          .slide-card {
            left: 16px;
            right: 16px;
            bottom: 44px;
            width: auto;
            padding: 16px 18px;

            .slide-user {
              margin-bottom: 10px;

              .slide-avatar {
                width: 20px;
                height: 20px;
              }

              .slide-username {
                font-size: 9px;
                letter-spacing: 1.5px;
              }
            }

            .slide-title {
              font-size: 16px;
              margin-bottom: 12px;
            }

            .slide-btn {
              padding: 7px 16px;
              font-size: 8px;
              letter-spacing: 2px;
            }
          }
        }

        .carousel-dots {
          bottom: 18px;

          .carousel-dot {
            width: 20px;

            &.active {
              width: 32px;
            }
          }
        }
      }
    }

    .activity-bar {
      padding: 18px 20px;
      gap: 12px;

      .bar-date {
        font-size: 8px;
        letter-spacing: 2px;
        line-height: 1.8;
      }

      .bar-divider {
        height: 36px;
      }

      .bar-content {
        min-width: 0;

        .bar-title {
          font-size: 14px;
          margin-bottom: 3px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .bar-sub {
          font-size: 10px;
          line-height: 1.6;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .bar-right {
        gap: 0;

        .bar-count {
          display: none;
        }

        .bar-join {
          padding: 8px 14px;
          font-size: 8px;
          letter-spacing: 1.5px;
          white-space: nowrap;
        }
      }
    }

    .activity-module {
      padding: 40px 24px 0;

      .activity-inner {
        display: block;
        max-width: none;

        .act-text {
          position: static;

          .act-eyebrow {
            font-size: 8px;
            letter-spacing: 3px;
            margin-bottom: 8px;
          }

          .act-title {
            font-size: 26px;
            margin-bottom: 12px;
            line-height: 1.2;
          }

          .act-desc {
            font-size: 12px;
            line-height: 1.9;
            margin-bottom: 12px;
          }

          .act-date {
            font-size: 9px;
            margin-bottom: 18px;
          }

          .act-join {
            padding: 9px 22px;
            font-size: 8px;
            margin-bottom: 28px;
          }
        }
      }
    }

    .footer-cta {
      margin-top: 40px;
      padding: 56px 24px;

      .footer-heading {
        font-size: 28px;
        line-height: 1.15;
        margin-bottom: 16px;
      }

      .footer-body {
        font-size: 12px;
        line-height: 2;
        max-width: 280px;
        margin-bottom: 32px;
      }

      .footer-btns {
        flex-direction: column;
        align-items: center;
        gap: 10px;

        .btn-outline-white,
        .btn-white {
          width: 220px;
          padding: 12px 32px;
          font-size: 9px;
        }
      }

      .footer-copy {
        margin-top: 40px;
      }
    }
  }
}
</style>